import React from 'react'
import Logo from '../Logo/Logo.js'

const LogoSection = () => {
  return (
    <div className="flex h-full items-center">
        <Logo />
    </div>
  )
}

export default LogoSection
